import React, { useState } from "react";
import { FaEnvelope, FaLock, FaEye, FaEyeSlash } from "react-icons/fa";
import logo from "../assets/logo/logo-1.png";
import { loginUser } from "../services/axios.function";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { ClipLoader } from "react-spinners";


const Login = () => {
  const navigate = useNavigate();
  const [passwordVisible, setPasswordVisible] = useState(false);
  const [formData, setFormData] = useState({ email: "", password: "" });
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [hover, setHover] = useState(false);

  const validateForm = () => {
    let newErrors = {};
    if (!formData.email) newErrors.email = "Email is required";
    if (!formData.password) newErrors.password = "Password is required";
    else if (formData.password.length < 6)
      newErrors.password = "Password must be at least 6 characters";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    setErrors({ ...errors, [e.target.name]: "" });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;
    setLoading(true);
    try {
      const response = await loginUser({
        email: formData.email,
        password: formData.password,
      });
      if (response?.data?.isSuccess) {
        const admin = {
          email: response?.data?.admin?.email,
          token: response?.data?.authToken,
        };
        localStorage.setItem("authData", JSON.stringify(admin));
        toast.success(response.data.message);
        navigate("/dashboard");
      } else {
        toast.error(response?.data?.message || "Login failed");
      }
    } catch (error) {
      toast.error(
        error?.response?.data?.message ||
        error?.message ||
        "Something went wrong!"
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      className="d-flex justify-content-center align-items-center"
      style={{
        minHeight: "100vh",
        backgroundColor: "#f0f2f5",
        padding: "20px",
      }}
    >
      <div
        className="custom-login-card shadow-lg p-4"
        style={{
          width: "100%",
          maxWidth: "420px",
          minHeight: "400px",
          borderRadius: "10px",
          background: "#fff",
          boxSizing: "border-box",
        }}
      >
        {/* Logo */}
        <div className="text-center mb-3">
          <img
            src={logo}
            alt="logo"
            style={{
              maxWidth: "160px",
              width: "100%",
              height: "auto",
            }}
          />
        </div>

        {/* Headings */}
        <p
          className="fw-bold mb-1"
          style={{
            fontSize: "1rem",
            wordWrap: "break-word",
            textAlign: "left",
          }}
        >
          Sign In to Your Festival Greetings App Admin Account
        </p>
        <p
          className="text-muted mb-4"
          style={{
            fontSize: "0.9rem",
            textAlign: "left",
          }}
        >
          Enter your email & password to login
        </p>

        {/* Login Form */}
        <form onSubmit={handleSubmit}>
          {/* Email */}
          <div className="mb-3 position-relative custom-input-group">
            <div className="input-group custom-input">
              <span className="input-group-text custom-icon">
                <FaEnvelope />
              </span>
              <input
                type="email"
                className={`form-control custom-form-control ${errors.email ? "is-invalid" : ""
                  }`}
                name="email"
                placeholder="Enter your email"
                value={formData.email}
                onChange={handleChange}
                style={{ fontSize: "0.9rem" }}
              />
            </div>
            {errors.email && (
              <small className="text-danger">{errors.email}</small>
            )}
          </div>

          {/* Password */}
          <div className="mb-2 position-relative custom-input-group">
            <div className="input-group custom-input">
              <span className="input-group-text custom-icon">
                <FaLock />
              </span>
              <input
                type={passwordVisible ? "text" : "password"}
                className={`form-control custom-form-control ${errors.password ? "is-invalid" : ""
                  }`}
                name="password"
                placeholder="Enter your password"
                value={formData.password}
                onChange={handleChange}
                style={{ fontSize: "0.9rem" }}
              />
              <span
                className="input-group-text custom-password-toggle"
                onClick={() => setPasswordVisible(!passwordVisible)}
                style={{ cursor: "pointer" }}
              >
                {passwordVisible ? <FaEyeSlash /> : <FaEye />}
              </span>
            </div>
            {errors.password && (
              <small className="text-danger">{errors.password}</small>
            )}
          </div>
          <br />

          {/* Submit Button */}
          <button
            type="submit"
            className="w-100"
            disabled={loading}
            onMouseEnter={() => setHover(true)}
            onMouseLeave={() => setHover(false)}
            style={{
              backgroundColor: hover ? "#8B4513" : "#693807",
              color: "#fff",
              fontWeight: "500",
              borderRadius: "6px",
              border: "none",
              padding: "10px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "8px",
              transition: "0.3s",
              width: "100%",
            }}
          >
            {loading ? (
              <ClipLoader size={22} color="#fff" />
            ) : (
              "" // <MdLogin size={22} />
            )}
            Sign In
          </button>
        </form>
      </div>
    </div>
  );
};

export default Login;
